module.exports = __webpack_public_path__ + "img/como-funciona-relink-1.18615c6.webp";